import { createRootRouteWithContext, HeadContent, Outlet } from "@tanstack/react-router";
import { TanStackRouterDevtools } from "@tanstack/react-router-devtools";
import { Client as UrqlClient } from "urql";

import type { AuthContextType } from "@/context/auth-provider";

import { NavigationProgress } from "@/components/navigation-progress";
import { Toaster } from "@/components/ui/sonner";

interface RouterContext {
  urqlClient: UrqlClient;
  auth: AuthContextType;
}

export const Route = createRootRouteWithContext<RouterContext>()({
  component: () => {
    return (
      <>
        <HeadContent />
        <NavigationProgress />
        <Outlet />
        <Toaster duration={5000} />
        {import.meta.env.MODE === "development" && (
          <TanStackRouterDevtools position="bottom-right" />
        )}
      </>
    );
  },
  head: () => ({
    meta: [
      {
        title: "See It Send It Administration",
      },
    ],
  }),
});
